import React from 'react';
import PropTypes from 'prop-types';
import { EmailIcon } from '@domain-group/fe-co-icon';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import * as styles from './allhomes-agent-mobile-cta.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgentMobileCTA = _ref => {
  var phone = _ref.phone,
    onEmailClick = _ref.onEmailClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX("div", {
    css: styles.mobileCTA
  }, phone && ___EmotionJSX("div", {
    css: styles.buttonContainer
  }, ___EmotionJSX(CallButton, {
    css: styles.button,
    phone: phone
  })), onEmailClick && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX("div", {
    css: styles.buttonContainer
  }, ___EmotionJSX(Button, {
    css: styles.button,
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: () => {
      sendEvent('email-click');
      onEmailClick();
    }
  }, "Email"))));
};
AgentMobileCTA.propTypes = {
  onEmailClick: PropTypes.func,
  phone: PropTypes.string
};
AgentMobileCTA.defaultProps = {
  phone: undefined,
  onEmailClick: undefined
};
export default withEventBoundary('mobile-enquiry-cta')(AgentMobileCTA);